import React from 'react';
import SignupContainer from 'views/SignupContainer';
import VerifyEmailForgotPassForm from 'shared/components/Forms/VerifyEmailForgotPass';
import { useLocation } from 'react-router-dom';

const VerifyEmailForgotPass: React.FC = () => {
  const location = useLocation();
  return (
    <SignupContainer>
      <VerifyEmailForgotPassForm email={location.state} forgotPass={true} />
    </SignupContainer>
  );
};

export default VerifyEmailForgotPass;
